<template>
  <!--Blog start-->
  <section class="team-bg" id="news">
    <div class="animation-circle-inverse">
      <i></i>
      <i></i>
      <i></i>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-8 offset-md-2 text-center">
          <div class="section-title">
            <h2>Our Recent Blog</h2>
            <img src="../../assets/images/title-line.png" alt="/title-line" />
            <!-- <div class="line"></div> -->
            <p>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Rem
              autem voluptatem obcaecati! ipsum dolor sit Rem autem voluptatem
              obcaecati
            </p>
          </div>
        </div>
        <div class="col-md-12">
          <swiper
            :modules="modules"
            :slides-per-view="3"
            :space-between="30"
            :loop="true"
            :breakpoints="{
              '@0.50': {
                slidesPerView: 1,
                spaceBetween: 5,
              },
              '@0.75': {
                slidesPerView: 2,
                spaceBetween: 5,
              },
              '@1.50': {
                slidesPerView: 3,
                spaceBetween: 15,
              },
            }"
          >
            <swiper-slide v-for="image in images" :key="image.id">
              <div class="item news-slid">
                <div class="news-box">
                  <router-link :to="{ name: 'Blogdetails' }">
                    <img
                      src="../../assets/images/blog/1.jpg"
                      alt="news-1"
                      class="img-fluid"
                    />
                  </router-link>
                  <div class="blog-hover">
                    <h4>lorem ipsum dolor sit amet</h4>
                    <ul class="list-inline blog-details-list">
                      <li><a href="#">John Doe</a></li>
                      <li><a href="#">1 Oct</a></li>
                      <li><a href="#">25 comments</a></li>
                      <li><a href="#">3 View</a></li>
                    </ul>
                  </div>
                </div>

                <div class="news-text">
                  <p>
                    lorem ipsum dolor sit amet, consecteturamet adipisicing
                    elit, tempor incididunt ut labore. lorem ipsum dolor sit
                    amet.
                  </p>
                  <router-link :to="{ name: 'Blogdetails' }" class="btn-theme"
                    >View more</router-link
                  >
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
  </section>
  <!--Blog end -->
</template>
<script>
import SwiperCore, {
  Navigation,
  Parallax,
  Pagination,
  Scrollbar,
  A11y,
} from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
SwiperCore.use(Navigation);
export default {
  name: "Blog",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      modules: [Navigation, Pagination, Scrollbar, A11y],
      images: [
        {
          id: 1,
          imageUrl: require("../../assets/images/ss/1.png"),
        },
        {
          id: 2,
          imageUrl: require("../../assets/images/ss/2.png"),
        },
        {
          id: 3,
          imageUrl: require("../../assets/images/ss/3.png"),
        },
        {
          id: 4,
          imageUrl: require("../../assets/images/ss/4.png"),
        },
        {
          id: 5,
          imageUrl: require("../../assets/images/ss/2.png"),
        },
        {
          id: 6,
          imageUrl: require("../../assets/images/ss/1.png"),
        },
      ],
    };
  },
};
</script>
